export default __webpack_public_path__ + "static/media/cases2.3675bca7.webp";